import axios, {AxiosInstance, AxiosRequestConfig} from "axios";
import { getLocale } from "@/i18n";

abstract class AxiosService {
    axiosInstance: AxiosInstance;

    constructor(baseUrl: string) {
        // for local development
        this.axiosInstance = axios.create({
            baseURL: baseUrl
        });
    }

    updateBaseUrl(baseUrl: string) {
        // for stages (after environment.json is fetched)
        this.axiosInstance.defaults.baseURL = baseUrl;
    }

    private async createConfig() {
        const currentLocale = getLocale();

        const headers = {
            'RH-Locale': currentLocale === 'cz'? 'cs' : currentLocale,
        } as any;

        return {
            headers: headers,
        } as AxiosRequestConfig;
    }

    async get<T = any>(endpoint: string, parameters: object) {
        const config = await this.createConfig()
        return await this.axiosInstance.get<T>(endpoint, {
            ...config,
            params: parameters,
        });
    }

    async post<T = any>(endpoint: string, payload: object) {
      const config = await this.createConfig();
        return await this.axiosInstance.post<T>(endpoint, payload, config);
    }

    async postWithCaptcha<T = any>(endpoint: string, payload: object, captchaToken: string) {
      const config = await this.createConfig();
      return await this.axiosInstance.post<T>(endpoint, payload, {
        ...config,
        headers: {
          ...config.headers,
          'rmd-app-token': captchaToken,
        }
      });
    }

    async getBlob(endpoint: string) {
        const config = await this.createConfig();
        return await this.axiosInstance.get(endpoint, {
            ...config,
            responseType: 'blob',
        });
    }
}

class ApiService extends AxiosService {
    constructor() {
        super(process.env.VUE_APP_BOOKING_SERVICE_URL);
    }
}

class LegacyApiService extends AxiosService {
    constructor() {
        super(process.env.VUE_APP_API_URL);
    }
}

const apiService = new ApiService();
const legacyApiService = new LegacyApiService();

export {apiService, legacyApiService};
